import { COLORS } from '../colors';
import { createGrid, forEachColumn, HEIGHT, WIDTH, getIndex, minmax, setCell } from '../utils';

const PADDLE_Y = HEIGHT - 2;
const PADDLE_WIDTH = 5;

const getBricks = () => {
  if (window.__game_win) {
    return [{
      x: 4, y: 4, width: 1
    }, {
      x: 4, y: 5, width: 1
    }, {
      x: 4, y: 6, width: 1
    }, {
      x: 4, y: 7, width: 1
    }, {
      x: 5, y: 4, width: 1
    }, {
      x: 6, y: 4, width: 1
    }, {
      x: 6, y: 5, width: 1
    }, {
      x: 6, y: 6, width: 1
    }, {
      x: 6, y: 7, width: 1
    }, {
      x: 5, y: 7, width: 1
    }, {
      x: 8, y: 4, width: 1
    }, {
      x: 8, y: 5, width: 1
    }, {
      x: 8, y: 6, width: 1
    }, {
      x: 8, y: 7, width: 1
    }, {
      x: 10, y: 4, width: 1
    }, {
      x: 9, y: 5, width: 1
    }, {
      x: 9, y: 6, width: 1
    }, {
      x: 10, y: 7, width: 1
    }]
  }
  return[{
    x: 1, y: 1,
    width: 3
  }, {
    x: 11, y: 1,
    width: 3
  }, {
    x: 6, y: 2,
    width: 3
  }, {
    x: 2, y: 3,
    width: 3
  }, {
    x: 10, y: 3,
    width: 3
  }, {
    x: 3, y: 5,
    width: 3
  }, {
    x: 9, y: 5,
    width: 3
  }, {
    x: 1, y: 7,
    width: 3
  }, {
    x: 11, y: 7,
    width: 3
  }, {
    x: 6, y: 7,
    width: 3
  }]
}

export class BreakoutMode {
  constructor({ addInteractionListener }) {
    this.state = {
      time: 0,
      paddleX: 8,
      ballX: Math.round(Math.random() * (WIDTH - 2)) + 1,
      ballY: 0,
      ballVX: -1,
      ballVY: 1,
      hideBall: false,
      hitTime: 10000,
      hits: 0,
      yOffsetTick: 0,
      bricks: getBricks()
    }
    addInteractionListener(({x}) => {
      this.state.paddleX = minmax(x, Math.floor(PADDLE_WIDTH/2), WIDTH - Math.ceil(PADDLE_WIDTH/2));
    }, {onHover: true, outsideBounds: true});
  }
  update(delta) {
    this.state.hitTime += delta;

    // only move ball on tick
    const tickLength = Math.max(50, 100 - (5 * this.state.hits));

    let tick = false;
    this.state.time += delta;
    if (this.state.time > tickLength) {
      tick = true;
      this.state.time = this.state.time % tickLength;
    }

    if (tick && !this.state.hideBall) {
      this.state.ballX += this.state.ballVX;
      this.state.ballY += this.state.ballVY;
      if (this.state.ballX <= 0 || this.state.ballX >= WIDTH - 1) {
        this.state.ballVX *= -1;
      }
      if (
        (
          Math.round(this.state.ballY) === PADDLE_Y -1 ||
          Math.round(this.state.ballY) === PADDLE_Y
        ) &&
        this.state.ballVY > 0 &&
        Math.abs(this.state.ballX - this.state.paddleX) < PADDLE_WIDTH * 0.8
      ) {
        this.state.ballVY *= -1;
        this.state.hitTime = 0;
        this.state.hits += 1;
      }
      if (this.state.ballY <= 0 ) {
        this.state.ballVY *= -1;
      }

      this.state.bricks = this.state.bricks.filter(b => !b.hit)

      if (this.state.ballVY < 0) {

        this.state.bricks.forEach(brick => {
          const hit = (
            this.state.ballY === brick.y &&
            this.state.ballX >= brick.x &&
            this.state.ballX <= brick.x + brick.width
          );
          if (hit) {
            this.state.ballVY *= -1;
            brick.hit = true;
            if (this.state.yOffsetTick >= 1) {
              this.state.yOffsetTick = 0;
            } else {
              this.state.yOffsetTick += 1;
            }  
          }
        });
      }

      if (this.state.ballY > HEIGHT - 1 ) {
        this.state.hideBall = true;
        this.state.hits = 0;
        setTimeout(() => {
          this.state.ballX = Math.round(Math.random() * (WIDTH - 2)) + 1;
          this.state.ballY = 0;
          this.state.hideBall = false;
          this.state.bricks = getBricks();
        }, 500);
      }
    }

    if (this.state.bricks.length === 0) {
      // player wins!
      window.__game_win = true;
      setTimeout(() => {
        if (this.state.bricks.length === 0) {
          this.state.bricks = getBricks();
        }
      }, 500);
    }

  }
  getData() {
    const grid = createGrid();
    
    const paddleWidth = PADDLE_WIDTH;

    for (let index = -Math.floor(paddleWidth/2); index < paddleWidth - Math.floor(paddleWidth/2); index++) {
      const x = this.state.paddleX - index;
      if (x > -1 && x < WIDTH) {
        grid[getIndex(x, PADDLE_Y)] = true;
      }
    }

    this.state.bricks.forEach(({x, y, width, hit}) => {
      for (let index = 0; index < width; index++) {
        const xx = x + index;
        setCell(grid, xx, y, hit ? 'orange': true)
      }
    });

    if (!this.state.hideBall) {
      const color = this.state.hitTime < 200 ? 'orange' : true;
      grid[getIndex(Math.round(this.state.ballX), Math.round(this.state.ballY))] = color;
    }

    return grid;
  }
}